import ClubHintRepository from './ClubHintRepository';
import KindergartenHintRepository from './KindergartenHintRepository';

/**
 * Selects the hint API repository for an institution type. Both repositories expose the same static interface
 * (getCount / getNew / getCategories / getProblems / solveProblem / updateProblem), so the shared HintPage /
 * HintOverlay / HintCounter components are institution-agnostic.
 *
 * @param {('club'|'kindergarten')} institutionType
 */
export default function hintRepositoryFor(institutionType) {
    return institutionType === 'kindergarten' ? KindergartenHintRepository : ClubHintRepository;
}
